export const isFullStatic = false
export const staticPath = "/usr/share/front/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"